import React from 'react';
import { MapPin, Phone, Clock, Send } from 'lucide-react';
import { useSettings } from '../src/contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Футер для публичных страниц (/takeaway).
 * Для table/:id не показывается — гость в зале, у него всё перед глазами.
 */
const Footer: React.FC = () => {
  const { settings } = useSettings();
  const { language } = useLanguage();
  const hours = settings.workingHours;

  const labels = {
    ru: { address: 'Адрес', phone: 'Телефон', hours: 'Часы работы', follow: 'Мы в соцсетях', rights: 'Все права защищены' },
    ky: { address: 'Дарек', phone: 'Телефон', hours: 'Жумуш убактысы', follow: 'Соц. тармактар', rights: 'Бардык укуктар корголгон' },
    en: { address: 'Address', phone: 'Phone', hours: 'Hours', follow: 'Follow us', rights: 'All rights reserved' },
    zh: { address: '地址', phone: '电话', hours: '营业时间', follow: '关注我们', rights: '版权所有' },
  } as const;
  const l = labels[language] || labels.ru;

  return (
    <footer className="mt-12 mb-28 px-2">
      <div className="bg-[var(--bg-card)] rounded-3xl border border-[var(--glass-border)] p-6 space-y-4">
        <h3 className="font-serif text-xl font-bold text-[var(--text-primary)]">
          {settings.restaurantName[language] || settings.restaurantName.ru}
        </h3>

        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-3 text-[var(--text-secondary)]">
            <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
            <span>{l.address}: г. Бишкек</span>
          </div>

          <a
            href="tel:+996555000000"
            className="flex items-start gap-3 text-[var(--text-secondary)] hover:text-[var(--accent-color)] transition-colors"
          >
            <Phone className="w-4 h-4 mt-0.5 shrink-0" />
            <span>+996 555 000 000</span>
          </a>

          {hours && (
            <div className="flex items-start gap-3 text-[var(--text-secondary)]">
              <Clock className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{l.hours}: {hours.open}–{hours.close}</span>
            </div>
          )}

          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-3 text-[var(--text-secondary)] hover:text-[var(--accent-color)] transition-colors"
          >
            <Send className="w-4 h-4 mt-0.5 shrink-0" />
            <span>{l.follow}</span>
          </a>
        </div>

        <p className="pt-3 border-t border-[var(--glass-border)] text-[11px] text-[var(--text-secondary)]">
          © {new Date().getFullYear()} {settings.restaurantName[language] || settings.restaurantName.ru} · {l.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
